import { useState, useEffect, useLayoutEffect } from "react";

/** Components */
import {
  Table,
  Tab,
  TableBody,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  TablePagination,
  Button,
  TextField,
  ButtonGroup,
  TableFooter,
  Collapse,
  Tooltip,
  Tabs,
  Dialog,
  Paper,
} from "@mui/material";
import { TreeMenu } from "../../commons/renderTreeMenu.component";
import { FilterBy } from "../../commons/filter.component";
import { ExpTicketDetail, ImpTicketDetail } from "./ticketDetail";
import { ticketStatusOptions } from "../../commons/SelectStatusButton";
import LoadingProgress from "../../commons/LoadingProgress.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";

/** Api & Function */
import { getImpTickets, getExpTickets, getExportTicketMenu, getImportTicketMenu } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import moment from "moment";

/** Hook */
import { useTranslation } from "react-i18next";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { statusColor } from "../../config";
import { convertQueryStringToObject } from "../../../services/libService";
import { useParamFilter } from "../../commons/customHook";
import { useDispatch } from "react-redux";

const cols = ["ID", "Ngày", "Số phiếu xuất", "Số phiếu nhập", "Từ kho", "Đến kho", "Biển số xe", "Lit", "L15", "USG", "Kg", "Trạng thái"];

const Detail = ({ id, onClose, type, onClickAtReplaceId, onDelete, onSaveResponse }) => {
  return (
    <Dialog open={Boolean(id)} onClose={onClose} maxWidth={false} fullWidth>
      <div align="center" style={{ padding: 10, height: "100vh" }}>
        {type === 1 ? <ExpTicketDetail ticketid={id} onClickAtReplaceId={onClickAtReplaceId} onDelete={onDelete} /> : <ImpTicketDetail ticketid={id} onSaveResponse={onSaveResponse} />}
      </div>
    </Dialog>
  );
};
export default function TicketList() {
  // hook
  const [t] = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();

  const { ticketId } = useParams();
  const history = useHistory();
  const filter = convertQueryStringToObject(location.search);
  const { fetchData, data, setData, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter(
    { page: 1, per_page: 50, tab: 1 },
    filter.tab == null || +filter.tab === 1 ? getExpTickets : getImpTickets
  );

  // state
  const [treeData, setTreeData] = useState();
  const [isSearchOpen, setSearchOpen] = useState(true);
  const [input, setInput] = useState({
    // filter input
    code: filter.code || null,
    start_date: filter.start_date || null,
    end_date: filter.end_date || null,
    status: null,
    fkey: filter.fkey || null,
  });

  // event
  const handleRowClick = (e, id) => {
    history.push(`/ticket/${id}${location.search}`);
  };
  const handleSearch = () => {
    fetchData((prev) => ({ ...input, per_page: prev.per_page, status: input?.status, tab: filter?.tab }));
  };
  const handleDeleteTicket = (id) => {
    setData((prev) => prev.map((item) => (item.id === id ? { ...item, status: "DELETED" } : item)));
  };
  const handleSaveResponse = (id) => {
    setData((prev) => {
      return prev.map((item) => (item.id === id ? { ...item, status: "APPROVED" } : item));
    });
  };

  // effect
  useLayoutEffect(() => {
    fetchData(convertQueryStringToObject(location.search));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (filter.tab == null) return;
    (+filter.tab === 1 ? getExportTicketMenu : getImportTicketMenu)().then((res) => {
      res.code === 200 && setTreeData(res.data);
    });
  }, [filter.tab]);

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN VẬN CHUYỂN NỘI BỘ XE XITEC"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <div style={{ justifyContent: "space-between", display: "flex", backgroundColor: "#b3deff", marginBottom: 20, marginTop: 10, height: 40 }}>
        <Tabs
          style={{ height: 40 }}
          onChange={(e, value) => {
            fetchData((prev) => ({ per_page: prev.per_page, tab: +value }), value === 1 ? getExpTickets : getImpTickets);
            setInput(null);
          }}
          value={+filter.tab || 1}
        >
          <Tab label={t("Kho xuất")} value={1} />
          <Tab label={t("Kho nhập")} value={2} />
        </Tabs>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Tooltip title="Tạo mới">
            <Button variant="outlined" color="primary" onClick={() => history.push("/createticket")}>
              <AddIcon />
            </Button>
          </Tooltip>
          <Button onClick={() => setSearchOpen((prev) => !prev)} variant="outlined">
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      <Collapse in={isSearchOpen}>
        <TextField
          InputProps={{ style: { minWidth: 200 } }}
          size="small"
          variant="outlined"
          label={t("Mã tra cứu")}
          value={input?.fkey || ""}
          onChange={(e) => setInput((prev) => ({ ...prev, fkey: e.target.value }))}
          style={{ margin: "5px" }}
        />
        <TextField
          InputProps={{ style: { minWidth: 200 } }}
          size="small"
          variant="outlined"
          label={t("Số phiếu xuất")}
          value={input?.code || ""}
          onChange={(e) => setInput((prev) => ({ ...prev, code: e.target.value }))}
          style={{ margin: "5px" }}
        />
        <FilterBy
          style={{ display: "inline-flex", minWidth: 200, margin: "5px" }}
          label={t("Trạng thái")}
          getOptionLabel={(option) => t(option) || ""}
          isOptionEqualToValue={(option, value) => option === value}
          getDataFunc={() => Promise.resolve({ data: ticketStatusOptions, code: 200 })}
          value={input?.status || null}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, status: newValue }))}
          // eslint-disable-next-line eqeqeq
          setDefaultFunc={(option) => setInput((prev) => ({ ...prev, status: option.find((i) => i == filter.status) }))}
          triggerSetDefaultFunc
        />
        <CustomDatePicker label={t("Từ ngày")} value={input?.start_date} onChange={(value) => setInput((prev) => ({ ...prev, start_date: value }))} sx={{ margin: "5px" }} />
        <CustomDatePicker label={t("Đến ngày")} value={input?.end_date} onChange={(value) => setInput((prev) => ({ ...prev, end_date: value }))} sx={{ margin: "5px" }} />
        <Button variant="outlined" onClick={handleSearch} style={{ margin: "10px 0" }}>
          {t("Tìm kiếm")}
        </Button>
      </Collapse>
      <div style={{ display: "flex" }}>
        <TreeMenu data={treeData} onClick={(query) => fetchData((prev) => ({ ...query, tab: filter.tab, per_page: prev.per_page }))} isExpand={!isSearchOpen} onExpand={() => setSearchOpen(false)} />
        {loading ? (
          <LoadingProgress />
        ) : (
          <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {cols.map((item, index) => (
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center" key={index}>
                      {t(item)}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.length ? (
                  data.map((item, index) => (
                    <TableRow hover style={{ cursor: "pointer" }} onClick={(e) => handleRowClick(e, item.id)} key={index}>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{item.id}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{moment(item.date).format("DD/MM/YYYY")}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{item.code}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{item.ext_inv_serial}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{item.from_inventory}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{item.to_inventory}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{item.license_plate}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{Math.round(item.lit).toLocaleString()}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{Math.round(item.l15).toLocaleString()}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{Math.round(item.usg).toLocaleString()}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>{Math.round(item.kg).toLocaleString()}</TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} width="12%">
                        <div className={`status ${item.status}`} style={{ color: statusColor[item.status] }}>
                          {t(item.status)}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={13}>
                      {t(isAllow ? "Không có dữ liệu" : "No permission")}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        )}
      </div>
      <Detail
        id={+ticketId}
        type={+filter.tab}
        onClose={() => history.push(`/ticket${location.search}`)}
        onClickAtReplaceId={(id) => history.push(`/ticket/${id}${location.search}`)}
        onDelete={handleDeleteTicket}
        onSaveResponse={handleSaveResponse}
      />
    </div>
  );
}
